import { useState, createContext } from 'react'
const TransactionDisplayContext = createContext(null);

const TransactionDisplayProvider = ({ children }) => {
    const [transactionDisplaySettings, setTransactionDisplaySettings] = useState({
        hideExceptionLinkToTransactions: false,
    })

    return (
        <TransactionDisplayContext.Provider value={{
            transactionDisplaySettings,
            setTransactionDisplaySettings
        }}>
            {children}
        </TransactionDisplayContext.Provider>
    )
}

export { TransactionDisplayContext, TransactionDisplayProvider }
